<template>
  <div>
    <v-snackbar v-model="snackbar" :color="snackbarColor">
      {{ snackbarContent }}
      <v-btn text @click="snackbar = false" timeout="3000">Close</v-btn>
    </v-snackbar>

    <!-- customer details -->
    <v-container class="mt-12">
      <v-card style="max-width: 800px; width: 95%; margin: auto; ">
        <v-card-text class="pa-0">
          <v-layout row class="profile">
            <v-flex xs4 md3>
              <v-layout column class="profileTitleBox pa-4">
                <v-flex xs class="my-2">
                  <span class="profileTitle">{{$t('name')}}</span>
                </v-flex>
                <v-flex xs3 class="my-2">
                  <span class="profileTitle">{{$t('email')}}</span>
                </v-flex>

                <v-flex xs3 class="my-2">
                  <span class="profileTitle">{{$t('phno')}}</span>
                </v-flex>
                <v-flex xs3 class="my-2">
                  <span class="profileTitle">{{$t('address')}}</span>
                </v-flex>
                <v-flex xs3 class="my-2">
                  <span class="profileTitle">{{$t('pincode')}}</span>
                </v-flex>
                <v-divider></v-divider>
                <v-flex xs3 class="my-4">
                  <span class="profileTitle">{{$t('password')}}</span>
                </v-flex>
              </v-layout>
            </v-flex>

            <v-flex xs8 md9>
              <v-layout column class="pa-4">
                <v-flex xs class="my-2 mx-5">
                  <span class="profileData">{{user.firstname}} {{user.lastname}}</span>
                </v-flex>
                <v-flex xs3 class="my-2 mx-5">
                  <span class="profileData">{{user.email}}</span>
                </v-flex>

                <v-flex xs3 class="my-2 mx-5">
                  <span class="profileData">{{user.phoneNumber}}</span>
                </v-flex>
                <v-flex xs3 class="my-2 mx-5">
                  <span class="profileData">{{user.address.address}}</span>
                </v-flex>
                <v-flex xs3 class="my-2 mx-5">
                  <span class="profileData">{{user.address.pinCode}}</span>
                </v-flex>
                <v-divider></v-divider>
                <v-flex xs3 class="my-2 mx-5">
                  <span class="profileData">
                    <v-btn
                      text
                      color="red"
                      class="white--text"
                      @click="passwordResetDialog=true"
                    >{{$t('resetPassword')}}</v-btn>
                  </span>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-container>

    <!-- License details -->
    <v-card class="mb-12 elevation-2 mt-12 mx-auto" width="80%">
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="6">
            <h3 v-if="licenseExists" >Licence</h3>
          </v-col>
          <v-col cols="12" sm="6" class="text-right">
            <v-btn
              v-if="!licenseExists"
              color="primary"
              @click="openLicenseDialog('new')"
              :ripple="false"
            >
              <v-icon left>mdi-smart-card-outline</v-icon>nouvelle licence
            </v-btn>
          </v-col>
        </v-row>

        <v-row v-if="licenseExists">
          <v-col cols="12" md="6">
            <v-card
              color="primary"
              class="pa-4"
              dark
              style="min-height: 320px;"
              :value="savedLicense"
            >
              <v-card-text>
                <v-row>
                  <v-col cols="12" sm="6" class="font-weight-medium">
                    <p>{{$t('number')}}</p>
                    <p>{{$t('type')}}</p>
                    <p>{{$t('deliveryPlace')}}</p>
                    <p>{{$t('deliveryDate')}}</p>
                    <p>{{$t('validity')}}</p>
                    <p v-if="savedLicense.type == 'OLD'">{{$t('specialElement1')}}</p>
                    <p v-if="savedLicense.type == 'OLD'">{{$t('specialElement2')}}</p>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <p>{{savedLicense.number}}</p>
                    <p>{{savedLicense.type}}</p>
                    <p>{{savedLicense.deliveryPlace}}</p>
                    <p>{{formatDate(savedLicense.deliveryOn)}}</p>
                    <p>{{formatDate(savedLicense.oldestDate)}}</p>
                    <p v-if="savedLicense.type == 'OLD'">{{savedLicense.specialElementOne}}</p>
                    <p v-if="savedLicense.type == 'OLD'">{{savedLicense.specialElementTwo}}</p>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  class="px-8"
                  color="yellow darken-3"
                  @click="openLicenseDialog('edit', savedLicense)"
                >{{$t('edit')}}</v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-dialog v-model="licenseDialog" width="fit-content">
      <v-card>
        <v-card-title class="headline primary white--text pa-2">Add new License</v-card-title>

        <v-card-text>
          <v-layout row wrap>
            <v-flex sm12 md12 lg6>
              <div class="pa-2">
                <span
                  style="display: inline-block;"
                  class="mr-3 font-weight-black subheading"
                >Ancien format</span>
                <v-switch style="display: inline-block;" color="primary" v-model="licenseFormat"></v-switch>
                <span
                  style="display: inline-block;"
                  class="mr-3 font-weight-black subheading"
                >Nouveau Format</span>
              </div>

              <img
                class="mt-4 text-center"
                v-if="!licenseFormat"
                src="../assets/ancien-permis-l.jpg"
                style="width: 600px"
              />

              <img
                class="mt-4 text-center"
                v-if="licenseFormat"
                src="../assets/nouveau-permis-l.jpg"
                style="width: 600px"
              />
            </v-flex>

            <v-flex sm6 md6 class="pa-3">
              <v-form v-model="licenseFormValid">
                <v-container>
                  <v-layout row wrap>
                    <v-flex xs12>
                      <h3>
                        <span
                          class="primary white--text"
                          style="padding: 4px 10px 4px 10px; border-radius:50%;"
                        >1</span>
                        Lieu de délivrance * :
                      </h3>
                      <v-text-field
                        :counter="20"
                        :rules="[v => !!v || 'Place of issue is required']"
                        label="Lieu de délivrance *"
                        required
                        v-model="placeOfIssue"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <h3>
                        <span
                          class="primary white--text"
                          style="padding: 4px 10px 4px 10px; border-radius:50%;"
                        >2</span>
                        Date de délivrance * :
                      </h3>
                      <v-layout class="justify-space-between" row wrap>
                        <v-flex class="px-3" md4 xs12>
                          <v-select
                            :items="days"
                            :rules="[v => !!v || 'Date is required']"
                            label="jour *"
                            v-model="dayOfIssue"
                          ></v-select>
                        </v-flex>
                        <v-flex class="px-3" md4 xs12>
                          <v-select
                            :items="months"
                            :rules="[v => !!v || 'Month is required']"
                            item-text="item"
                            item-value="value"
                            label="mois *"
                            v-model="monthOfIssue"
                          ></v-select>
                        </v-flex>
                        <v-flex class="px-3" md4 xs12>
                          <v-select
                            :items="years"
                            :rules="[v => !!v || 'Year is required']"
                            label="année *"
                            v-model="yearOfIssue"
                          ></v-select>
                        </v-flex>
                      </v-layout>
                    </v-flex>

                    <v-flex md12 xs12>
                      <h3>
                        <span
                          class="primary white--text"
                          style="padding: 4px 10px 4px 10px; border-radius:50%;"
                        >3</span>
                        Numéro de permis * :
                      </h3>
                      <v-text-field
                        :rules="[v => !!v || 'License Number is required']"
                        label="Numéro de permis *"
                        v-model="licenseNumber"
                      ></v-text-field>
                    </v-flex>

                    <v-flex xs12>
                      <h3>
                        <span
                          class="primary white--text"
                          style="padding: 4px 10px 4px 10px; border-radius:50%;"
                        >4</span>
                        Date d'obtention * :
                      </h3>
                      <v-layout class="justify-space-between" row wrap>
                        <v-flex class="px-3" md4 xs12>
                          <v-select
                            :items="days"
                            :rules="[v => !!v || 'Date is required']"
                            label="jour *"
                            v-model="dayOfExpiry"
                          ></v-select>
                        </v-flex>
                        <v-flex class="px-3" md4 xs12>
                          <v-select
                            :items="months"
                            :rules="[v => !!v || 'Month is required']"
                            item-text="item"
                            item-value="value"
                            label="mois *"
                            v-model="monthOfExpiry"
                          ></v-select>
                        </v-flex>
                        <v-flex class="px-3" md4 xs12>
                          <v-select
                            :items="years"
                            :rules="[v => !!v || 'Year is required']"
                            label="année *"
                            v-model="yearOfExpiry"
                          ></v-select>
                        </v-flex>
                      </v-layout>
                    </v-flex>

                    <v-flex xs12 v-if="!licenseFormat">
                      <h4>Renseignez ces deux champs s'ils apparaissent sur votre permis :</h4>
                      <v-layout row wrap>
                        <v-flex class="px-3" md6 xs12>
                          <v-text-field v-model="specialElementOne"></v-text-field>
                        </v-flex>
                        <v-flex class="px-3" md6 xs12>
                          <v-text-field v-model="specialElementTwo"></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-form>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            :disabled="!licenseFormValid"
            color="green darken-3"
            class="white--text px-5"
            :loading="addLicenseLoader"
            @click="saveLicense"
          >Soumettre</v-btn>

          <v-btn color="red darken-3" class="white--text px-5" @click="closeLicenseDialog">Annuler</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="passwordResetDialog" persistent width="600">
      <v-card>
        <v-card-title class="headline primary white--text pa-2" primary-title>Reset Password</v-card-title>

        <v-card-text class="pa-4">
          <p class="font-weight-bold subtitle">Enter new password:</p>
          <v-form ref="resetForm" v-model="resetFormValid">
            <v-col cols="12">
              <v-row xs12 class="pa-4">
                <v-text-field
                  v-model="password"
                  :rules="passwordRules"
                  type="password"
                  label="Password"
                ></v-text-field>
              </v-row>
              <v-row xs12 class="pa-4">
                <v-text-field
                  v-model="repeatPassword"
                  :rules="passwordRules"
                  type="password"
                  label="Repeat Password"
                ></v-text-field>
              </v-row>
            </v-col>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            :disabled="!resetFormValid"
            color="green darken-3"
            class="white--text px-5"
            :loading="resetLoader"
            @click="resetPassword"
          >Submit</v-btn>

          <v-btn color="red darken-3" dark @click="formReset()" class="px-5">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import moment from "moment";

export default {
  data() {
    return {
      passwordResetDialog: false,
      resetLoader: false,
      resetFormValid: false,
      passwordRules: [
        v => !!v || "Password is required",
        v => (v && v.length >= 6) || "Pincode must be 6 characters"
      ],

      password: "",
      repeatPassword: "",

      snackbar: false,
      snackbarContent: "",
      snackbarColor: "",

      licenseFormValid: false,

      days: [
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "20",
        "21",
        "22",
        "23",
        "24",
        "25",
        "26",
        "27",
        "28",
        "29",
        "30",
        "31"
      ],
      months: [
        { item: "Janvier", value: "01" },
        { item: "Février", value: "02" },
        { item: "Mars", value: "03" },
        { item: "Avril", value: "04" },
        { item: "Mai", value: "05" },
        { item: "Juin", value: "06" },
        { item: "Juillet", value: "07" },
        { item: "Aout", value: "08" },
        { item: "Septembre", value: "09" },
        { item: "Octobre", value: "10" },
        { item: "Novembre", value: "11" },
        { item: "Décembre", value: "12" }
      ],

      savedLicense: [],
      licenseExists: true,
      licenseFormat: true,
      licenseCardBorder: "",
      selectedLicense: "",
      addLicenseLoader: false,
      licenseDialog: false,

      licenseId: null,
      placeOfIssue: "",
      dayOfIssue: "",
      monthOfIssue: "",
      yearOfIssue: "",
      dayOfExpiry: "",
      monthOfExpiry: "",
      yearOfExpiry: "",
      licenseNumber: "",
      specialElementOne: "",
      specialElementTwo: "",
      licenseAction: null
    };
  },
  created() {
    this.getLicense();
  },
  methods: {
    resetPassword() {
      this.resetLoader = true;

      if (this.password == this.repeatPassword) {
        this.$http
          .post(
            "/reset-password?user-id=" +
              this.user.id +
              "&password=" +
              this.password
          )
          .then(() => {
            //console.log(res);

            this.snackbarContent =
              "Password changed successfully. You will be logged out now. Please login with your new password.";
            this.snackbarColor = "success";
            this.snackbar = true;
            this.resetLoader = false;
            this.formReset();
            let self = this;
            setTimeout(function() {
              self.logout();
            }, 5000);
          })
          .catch(e => {
            console.log(e.response);
            this.snackbarContent = "Error. Contact admin.";
            this.snackbarColor = "error";
            this.snackbar = true;

            this.resetLoader = false;
          });
      } else {
        this.snackbarContent = "Passwords dont match.";
        this.snackbarColor = "error";
        this.snackbar = true;

        this.resetLoader = false;
      }
    },
    formReset() {
      this.$refs.resetForm.reset();
      this.passwordResetDialog = false;
    },
    logout() {
      this.$store.commit("signout");
      window.location.href = "/login";
    },

    formatDate(date) {
      if (!date) return null;
      let d = date.substring(0, 10);

      const [year, month, day] = d.split("-");

      return day + "/" + month + "/" + year;
    },
    openLicenseDialog(action, license) {
      this.licenseAction = action;
      if (license != undefined) {
        this.editLicense(license);
      } else {
        this.licenseDialog = true;
      }
    },
    saveLicense() {
      if (this.licenseAction == "new") {
        let data = {
          deliveryOn:
            this.yearOfIssue + "-" + this.monthOfIssue + "-" + this.dayOfIssue,
          deliveryPlace: this.placeOfIssue,
          number: this.licenseNumber,
          type: this.licenseFormat ? "NEW" : "OLD",
          specialElementOne: this.specialElementOne,
          specialElementTwo: this.specialElementTwo,
          oldestDate:
            this.yearOfExpiry +
            "-" +
            this.monthOfExpiry +
            "-" +
            this.dayOfExpiry
        };

        let Uid = this.$store.getters.getUser.id;

        this.$http
          .post("/customer/" + Uid + "/driving-licence/save", data, {
            headers: { Authorization: "Bearer " + this.$store.state.token }
          })
          .then(res => {
            console.log(res);

            this.getLicense();
            this.licenseExists = true;
            this.licenseDialog = false;

            this.snackbarContent = "Licence enregistrée";
            this.snackbarColor = "success";
            this.snackbar = true;
          })
          .catch(() => {
            this.snackbarContent = "Erreur. Contactez l'administrateur.";
            this.snackbarColor = "error";
            this.snackbar = true;
          });
      } else if (this.licenseAction == "edit") {
       
        let data = {
          deliveryOn:
            this.yearOfIssue + "-" + this.monthOfIssue + "-" + this.dayOfIssue,
          deliveryPlace: this.placeOfIssue,
          number: this.licenseNumber,
          type: this.licenseFormat ? "NEW" : "OLD",
          specialElementOne: this.specialElementOne,
          specialElementTwo: this.specialElementTwo,
          oldestDate:
            this.yearOfExpiry +
            "-" +
            this.monthOfExpiry +
            "-" +
            this.dayOfExpiry
        };

        let Uid = this.$store.getters.getUser.id;

        this.$http
          .put(
            "/customer/" + Uid + "/edit/driving-licence/" + this.licenseId,
            data,
            {
              headers: { Authorization: "Bearer " + this.$store.state.token }
            }
          )
          .then(res => {
            console.log(res);

            this.getLicense();
            this.licenseExists = true;
            this.licenseDialog = false;

            this.snackbarContent = "Licence enregistrée";
            this.snackbarColor = "success";
            this.snackbar = true;

            this.licenseId = null;
          })
          .catch(() => {
            this.snackbarContent = "Erreur. Contactez l'administrateur.";
            this.snackbarColor = "error";
            this.snackbar = true;
          });
      }
    },
    editLicense(license) {
      
      this.yearOfIssue = parseInt(moment(license.deliveryOn).format("YYYY"));
      this.monthOfIssue = moment(license.deliveryOn).format("MM");
      this.dayOfIssue = moment(license.deliveryOn).format("DD");

      this.placeOfIssue = license.deliveryPlace;
      this.licenseNumber = license.number;
      this.licenseFormat = license.type == "NEW" ? true : false;
      this.specialElementOne = license.specialElementOne;
      this.specialElementTwo = license.specialElementTwo;

      this.yearOfExpiry = parseInt(moment(license.oldestDate).format("YYYY"));
      this.monthOfExpiry = moment(license.oldestDate).format("MM");
      this.dayOfExpiry = moment(license.oldestDate).format("DD");
      this.licenseId = license.id;
      this.licenseDialog = true;
    },
    closeLicenseDialog() {
      this.licenseDialog = false;
    },

    getLicense() {
      this.$http
        .get("/customer/" + this.user.id + "/driving-licence/findAll", {
          headers: { Authorization: "Bearer " + this.$store.state.token }
        })
        .then(res => {
          if (res.data.length != 0) {
            //this.$store.commit("saveLicense", res.data);
            this.savedLicense = res.data[0];
          }else {
            this.licenseExists = false;
          }
        })
        .catch(e => {
          console.log(e.response);
        });
    }
  },
  computed: {
    user() {
      return this.$store.getters.getUser;
    },
    years: function() {
      let d = new Date().getFullYear();

      let start = d - 18;
      let end = 1935;

      let t = [];
      for (let i = start; i >= end; i--) {
        t.push(i);
      }

      return t;
    },
    points: function() {
      let temp = [];

      for (let i = 0; i <= 12; i++) {
        temp.push(i);
      }

      return temp;
    }
  }
};
</script>

<style >
.contain {
  padding: 20px;
}

.profile {
  background: #fcb3c6;
}

.profileTitleBox {
  border-right: 1px solid #222222;
}

.profileTitle {
  color: #222222;
  letter-spacing: 2pt;
  font-size: 16px;
  font-weight: 600;
}

.profileData {
  color: #222222;
  font-size: 16px;
}
</style>